import { render, staticRenderFns } from "./GroupMember.vue?vue&type=template&id=6204cccf&scoped=true&"
import script from "./GroupMember.vue?vue&type=script&lang=js&"
export * from "./GroupMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204cccf",
  null
  
)

export default component.exports